import { useMemo } from 'react';

import type { So5FixtureEvent } from '__generated__/globalTypes';
import { useNextSo5FixtureTeamSlugs } from 'hooks/config/useNextSo5FixtureTeamSlugs';
import { joinFiltersWithOr } from 'lib/algolia';

type Props = {
  filterValue: string | undefined;
  eventType: So5FixtureEvent;
};

export const useFixtureFilterValue = ({ filterValue, eventType }: Props) => {
  const teamsPlayingNextFixture = useNextSo5FixtureTeamSlugs(eventType);
  const playingNextGameweekFilterValues = useMemo(
    () =>
      teamsPlayingNextFixture.reduce<Record<string, string>>(
        (acc, { slug, teamSlugs }) => ({
          ...acc,
          [slug]: joinFiltersWithOr(
            teamSlugs.flatMap(teamSlug => [
              `active_club.slug:${teamSlug}`,
              `active_national_team.slug:${teamSlug}`,
            ])
          ),
        }),
        {}
      ),
    [teamsPlayingNextFixture]
  );

  if (!filterValue) return null;

  return playingNextGameweekFilterValues[filterValue];
};
